export default {
  Title: 'Register your MFA method.',
  SubTitle:
    'Multi-factor Authentication is required for login to the Texas Digital Identity Solution and any of its integrated applications. If you have questions or concerns, please contact your organization\'s administrator.',
  InstructionsLink: 'Need help? Access the TDIS Enrollment Guide from the DIR webpage.',
  PhoneTitle: 'Register your mobile phone number.',
  PhoneSubTitle: 'Enter your mobile phone number to receive a verification code.​',
  PhoneVerifyTitle: 'Verify your mobile phone number.',
  PhoneVerifySubTitle: 'A verification code has been sent to your phone via text message',
  AuthenticatorAppTitle: 'Register your Authenticator App.',
  AuthenticatorAppSubTitle: 'To register, scan the QR code with your preferred authenticator app (not camera app).',
  AuthenticatorAppVerifyTitle: 'Verify your authenticator app.',
  AuthenticatorAppVerifySubTitle: 'Enter the 6-digit code from your authenticator app.',
  PasskeyTitle: 'Register your Passkey.',
  PasskeySubTitle: 'User a security key, Windows Hello, Touch ID, or Face ID to secure your account.​',
  PasskeyTitleVerify: 'Registering your Passkey.​',
  PasskeySubTitleVerify: 'Please verify your passkey to complete the registration process.',
  EnrollmentSuccessTitle: 'Account Created Successfully!',
  EnrollmentSuccessSubTitle: 'Your account has been set up with multi-factor authentication.',
  EnrollmentSuccessButton: 'Continue to Sign In',
  EnrollmentSuccessNextSteps: 'Next Steps',
  EnrollmentSuccessNextStepOne: 'Sign in with your new password.',
  EnrollmentSuccessNextStepTwo: 'Use your registered MFA method to verify your identity.',
  EnrollmentSuccessNextStepThree: 'Access your applications securely.',
};
